import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys as sharedQueryKeys } from '../../queryKeys';
import errorCodes from '../../util/errorCodes';
import { useAuth } from '../context/AuthContext';
import { login, loginWithActiveDirectory } from './loginApi';

const validateCredentials = credentials => {
  if (!(credentials?.token && credentials.refreshToken && credentials.expires)) {
    throw new Error(errorCodes.HTTP_RESPONSE_STATUS_UNAUTHORIZED);
  }
  return credentials;
};

const useAuthenticationMutation = mutationFn => {
  const { setToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: credentials => {
      queryClient.removeQueries({ queryKey: [sharedQueryKeys.USER] });
      setToken(credentials.token, credentials.refreshToken, credentials.expires);
    },
  });
};

export const useLoginMutation = () =>
  useAuthenticationMutation(({ username, password }) => login(username, password).then(validateCredentials));

export const useActiveDirectoryLoginMutation = () =>
  useAuthenticationMutation(adToken => loginWithActiveDirectory(adToken).then(validateCredentials));

export const useLogout = () => useAuth().clearAuth;
